<template>
    <f7-swiper-slide :class="`swatch ${small ? 'small' : ''} ${selected ? 'selected' : ''}`">
        <div
            :style="`background-color: ${course.color || topic.color}; background-image:url('${topic.data ? topic.data.imageUrl : ''}'); background-size: 750px 50px; background-position: -${(courseTopicIndex() * 160)}px bottom; background-repeat: repeat-x; `"
            class="innerSwatch hasActive"
            @click="goTo(link)"
        >

            <div class="oncard-title">
                <span>{{ course.name }}</span>
            </div>
            <svg
                v-if="completeAnim"
                class="checkmark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
            >
                <circle
                    class="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                />
                <path
                    :stroke="course.color || topic.color"
                    class="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
            </svg>

            <div
                v-if="!completeAnim && (isLearn || isLocked()) && ( isLocked() || (pgBarWidth() == 100) || topic.comingSoon || course.comingSoon)"
                :style="(topic.comingSoon || course.comingSoon) && !isLocked() ? 'line-height: 20px' : ''"
                class="playBall"
            >
                <!--  course.id === user.currentCourseId || <i
                    v-if="course.id === user.currentCourseId"
                    :style="`color:  ${course.color || topic.color}`"
                    class="icon ion ion-home"
                /> -->
                <i
                    v-if="isLocked()"
                    :style="`color:  ${course.color || topic.color}; ${small ? 'margin-top: -12px;' : ''}`"
                    class="icon ion ion-locked"
                />
                <i
                    v-else-if="pgBarWidth() == 100"
                    :style="`color:  ${course.color || topic.color}; padding-top: 2px`"
                    class="icon ion ion-checkmark"
                />
                <i
                    v-else-if="topic.comingSoon || course.comingSoon"
                    :style="`color:  ${course.color || topic.color}`"
                    class="coming-soon"
                >Soon</i>

            </div>
            <!--    :style="`background-image: url('${course.data ? course.data.imageUrl : ''}'); background-size: 142px 162px`" -->
            <div
                v-if="isLearn"
                class="statusBarWrap"
            >
                <div class="statusBarBg">
                    <div
                        :style="`width: ${pgBarWidth()}%`"
                        class="statusBar"
                    />
                </div>
            </div>
        </div>
        <!-- <div class="undercard-title"></div> -->
    </f7-swiper-slide>

</template>

<script>
import utils from '../js/utils';
import { CORAL_BRANDING } from '../js/constants';

export default {
    props: [
        'course',
        'topic',
        'locked',
        'disabled',
        'index',
        'link',
        'setCourseOnClick',
        'inPopup',
        'completeAnim',
        'isLearn',
        'isLogicalNext', // no ML on logicalNext
        'isNextUp',
        'small',
        'selected',
        'tabbar',
    ],
    store: ['api', 'user', 'fullDataIndex', 'unitsIndex', 'topicsIndex', 'coursesIndex', 'myTraits', 'nextMajor', 'currentCourse', 'progress'],
    data () {
        return {};
    },
    ready: function () {
        // console.log(this.comment)
    },
    watch: {},
    methods: {
        courseTopicIndex: function () {
            if (this.index) return this.index;
            if (!this.topicsIndex[this.course.topicId] || !this.topicsIndex[this.course.topicId].courses) {
                if (this.setCourseOnClick) return 8;
                return 0;
            }
            for (let i = 0; i < this.topicsIndex[this.course.topicId].courses.length; i++) {
                const element = this.topicsIndex[this.course.topicId].courses[i];
                if (element.id === this.course.id) {
                    if (this.setCourseOnClick) return i + 8;
                    return i;
                }
            }
            return 0;
        },
        pgBarWidth: function () {
            if (this.completeAnim || !this.isLearn) return 100;
            let width = 0;
            let eligible = 0;
            let completed = 0;
            for (let i = 0; i < this.coursesIndex[this.course.id].units.length; i++) {
                const u = this.coursesIndex[this.course.id].units[i];
                if (utils.checkTraits(this.myTraits, u)) {
                    eligible++;
                }
            }
            for (let i = 0; i < this.coursesIndex[this.course.id].units.length; i++) {
                const c = this.unitsIndex[this.coursesIndex[this.course.id].units[i].id];
                if (c && c.completed) {
                    completed++;
                    width = parseFloat(((completed * 100) / eligible).toFixed(0));
                }
            }
            if (width > 100) width = 100;
            return width;
        },
        isLocked: function () {
            // all open for subscribers
            if (this.user.isSubscribed) return false;
            // first two topics are open for everyone
            if (this.course.topicId === 16 ||
                this.course.topicId === 12 ||
                this.course.topicId === 39 ||
                this.course.topicId === 58 ||
                this.course.id === 16) return false;
            // open all asks
            if (this.course.type === 'ask') return false;
            // not in topics
            if (!this.fullDataIndex[this.course.topicId]) return true;
            if (this.locked) return true;
            if (!this.isLearn && !this.user.isSubscribed) return true;
            // first one always unlocked
            if (this.fullDataIndex[this.course.topicId].courses[0] && this.fullDataIndex[this.course.topicId].courses[0].id === this.course.id) {
                return false;
            }
            // first 3 if type is goals
            if (this.course.type === 'goal' && this.fullDataIndex[this.course.topicId].courses[1] && this.fullDataIndex[this.course.topicId].courses[1].id === this.course.id) {
                return false;
            }
            if (this.course.type === 'goal' && this.fullDataIndex[this.course.topicId].courses[2] && this.fullDataIndex[this.course.topicId].courses[2].id === this.course.id) {
                return false;
            }
            return true;
        },
        trackMl: function (type) {
            this.$http.post(`${this.api}/track/${this.course.id}`, {
                type,
            }).then(
                () => { }, () => { })
        },
        goTo: function () {
            if (this.completeAnim) return;
            if (this.course.comingSoon) return;
            if (!this.isLogicalNext) {
                this.trackMl(this.isNextUp ? 'nextup' : 'explore');
            }
            if (this.locked || this.disabled) return;
            if (this.isLocked()) {
                return f7.view.current.router.navigate(`/subscribeStart?redirect=${this.link}`);
            }
            this.currentCourse = this.course;
            console.log('Set currentcourse via course-card', this.course.id)
            if (this.setCourseOnClick) {
                this.setCourse(this.course.id);
                // return  f7.view.current.router.back();
            }
            let variant = parseFloat(localStore.getItem(`experiment-015_course-nav`));
            if (this.tabbar && !variant) {
                if (!pgap) window.history.pushState(null, "", '/web/courses/' + this.course.id);
                return this.$events.fire('change-course-tab', this.course);
            }
            if (this.inPopup) {
                f7.popup.get(`#${this.inPopup}`).open();
                f7.popup.get(`#${this.inPopup}`).close();
            }
            // var bodyStyles = document.body.style;
            // bodyStyles.setProperty('--f7-page-bg-color', this.topic.color);
            f7.views['main'].router.navigate(this.link, {
                // transition: 'f7-circle',
                // clearPreviousHistory: true,
            });
            // if (this.setCourseOnClick) {
            //     f7.views['main'].router.navigate('/home', {
            //         reloadPrevious: true,
            //     });
            // }
            // setTimeout(() => {
            //     bodyStyles.setProperty('--f7-page-bg-color', 'white');
            // }, 1000);
            if (pgap && window.TapticEngine) {
                window.TapticEngine.selection();
            }
        },
        setCourse: function (id) {
            if (this.completeAnim) return;
            if (this.course.comingSoon) return;
            if (this.inPopup) {
                f7.popup.get(`#${this.inPopup}`).open();
                f7.popup.get(`#${this.inPopup}`).close();
            } else if (this.courseId === CORAL_BRANDING && this.nextMajor !== 0) {
                // what was this again?
            }
            if (pgap && window.TapticEngine) {
                window.TapticEngine.selection();
            }
            if (this.isLocked()) return f7.view.current.router.navigate('/subscribeStart');
            this.nextMajor = 0;
            this.user.currentCourseId = id;
            this.$events.fire('user-save');
        }
    }
};
</script>
<style lang="less" scoped>
@import '../css/colors.less';
.checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 4;
    stroke-miterlimit: 10;
    stroke: rgba(255, 255, 255, 1);
    fill: rgba(255, 255, 255, 1);
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke: #fff;
    stroke-miterlimit: 10;
    margin: 10% auto;
    box-shadow: inset 0px 0px 0px white;
    animation: fill 0.4s ease-in-out 0.4s forwards, scale 0.3s ease-in-out 0.9s both;
}

.checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

.coming-soon {
    text-transform: uppercase;
    padding: 0px 10px;
    line-height: 23px;
}
.small .coming-soon {
    font-size: 14px;
    line-height: 28px;
}
@keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}
@keyframes scale {
    0%,
    100% {
        transform: none;
    }
    50% {
        transform: scale3d(1.1, 1.1, 1);
    }
}
@keyframes fill {
    100% {
        box-shadow: inset 0px 0px 0px 30px rgba(255, 255, 255, 0.33);
    }
}
</style>
